import Jolteon from './Jolteon';

export default Jolteon;



/** WEBPACK FOOTER **
 ** ./source/135-jolteon/index.js
 **/